<template>
  <footer class="bg-blue-dark pt-2 pb-2 webstore-footer">
    <nav>
      <div class="flex-col flex flex-wrap justify-between lang-wrap">
        <div class="flex flex-wrap footer__legal">
          <ul class="flex flex-wrap px-gap mx-0 my-1 pl-0 legal">
            <li v-for="(link, index) in links" :key="index" class="mb-1/2 font-light text-white legal-links">
				<a class="text-white text-sm" :href="link.href">{{ link.text }}<img class="inline ml-1/4 lazyLoad isLoaded" v-if="link?.img" :src="link.img" :alt="link?.alt"/></a>
				
			</li>
          </ul>
        </div>
        <div class="xs-12 col space-top-0 white-text footer__mobile-logo">
          <div class="logo-container visible-m">
            <a href="/" title="samsara" class="footer-logo">
              <!-- <img :src="ctfl_header_new.logo_mobile.url()" :alt="ctfl_header_new.logo_mobile.description"> -->
            </a>
          </div>
        </div>
		<p class="copyright text-white" >© 2023 Samsara Inc.</p>
      </div>
    </nav>
  </footer>
</template>
<style lang="scss" scoped>
  .footer__mobile-logo {
		opacity: 0.9;
		font-size: 13px;
		text-align: center;

		.logo-container {
			margin-bottom: 10px;
		}
        
		@media(min-width: 736px) {
			text-align: right;
			max-width: 145px;
		}
	}
  .footer__legal {
		width: 100%;
        
		@media(min-width: 736px) {
			max-width: 620px;
		}
	}
  .legal-links {
	font-size: 13px;
	width: 50%;
    color: white !important;
		&:nth-child(even) {
			padding-right: 15px;
		}
	}

  .legal-links a {
    color: white !important;
  }

	@media(min-width: 736px) {
		.legal-links {
			padding-right: 7px;
			width: auto;

			&:nth-child(even) {
				padding-right: 7px;
			}

		}

		.legal-links:nth-child(-n + 4)::after, 
		.legal-links:nth-child(n + 5)::after {
			content: '|';
			margin-left: 7px;
		}

		.legal-links:last-child::after {
			content: ' ';
		}
	}
	.copyright {
		padding-left: 8px;
	}

</style>
<script>
	import { mapActions } from 'vuex';
export default {
	data() {
		return {
			links: [],
		}
	},

  methods: {
		...mapActions('content', [
			'getFooterContent'
		]),
  },

  async created() {
	let footerContent = await this.getFooterContent();
		this.links = footerContent.supportLinks.links;
  }
};
</script>
